import HasObservableProperties from './has_observable_properties'

class BpmCounter {
  first = null //time of first beat
  last = null  //time of most recent beat

  constructor() {
    this.createObservableProperty('count')
  }

  isFirstBeat = () => this.first === null

  beat = () => {
    if(this.isFirstBeat()) {
      this.first = this.now()
      this.count = 0
    } else {
      this.last = this.now()
      this.count ++ 
    }
  }

  reset = () => {
    this.first = null
    this.last = null
    this.count = 0
  }

  now         = () => (new Date).getTime()
  miliseconds = () => this.last - this.first
  minutes     = () => this.miliseconds() / 60000
  bpm         = () => this.first ?  this.count / this.minutes() : 0
  bps         = () => this.bpm() / 60
  bph         = () => this.bpm() * 60
}

Object.assign(BpmCounter.prototype, HasObservableProperties)

export default BpmCounter
